<template>
  <CommonLoading
    v-if="loading"
  />

  <ListaDeAgendamentosForm
		:open= "editingOpen"
		:placeHolderValues= "editFormData"
		:consultores="consultores"
		@editing-data= "onSendEditingData"
		@update-open= "editingOpen = false"
		@segurado-badge="seguradoBadge"
		@remove-badge="deleteBadge"
		@empresa-lista="getEditData"
		@desvincular-empresa="deleteEmpresa"
	/>

  <AtendimentosWhatsAppTemplateForm
    :open="templateOpen"
    :templates="templatesWhats"
    @update-open= "templateOpen = false"
    @enviar-template = "enviarTemplate"
  />
  <div class="flex h-screen w-full bg-gray-100">

    <!-- SIDEBAR ESQUERDA -->
    <aside class="w-72 bg-white border-r border-gray-200 p-6">
  <h2 class="text-lg font-semibold mb-6">Caixa de atendimento</h2>

  <!-- Lista de agendamentos -->
  <div class="flex flex-col gap-4">
    <button
      v-for="agendamento in agendamentos"
      :key="agendamento.id"
      class="text-left font-medium text-gray-900"
      @click="handleAgendamentoSelecionado(agendamento.id)"
    >
      {{ agendamento.nome ?? 'Sem nome' }}
    </button>
  </div>

  <!-- Paginação -->
  <div class="flex flex-col gap-2 mt-10">
    <div class="flex justify-between items-center mt-2.5 space-x-4">
      <div class="flex items-center">
        <span class="text-sm text-gray-600">Página {{ currentPageAgendamento }} de {{ totalPagesAgendamento }} | Total de registros: {{ totalRecordsAgendamento }}</span>
      </div>
      <div class="flex sticky items-center space-x-2">
        <button @click="previousPageAgendamento" v-if="agendamentosPrevPageUrl" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Anterior</button>
        <button @click="nextPageAgendamento" v-if="agendamentosNextPageUrl" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Próximo</button>
        <input type="number" v-model="pageNumberAgendamento" min="1" :max="totalPagesAgendamento" class="border border-gray-300 rounded-md px-2 py-1 text-sm" placeholder="Ir para..." />
        <button @click="goToPage" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Ir</button>
      </div>
    </div>
  </div>
</aside>


    <!-- LISTA CENTRAL -->
    <div class="w-100 border-r border-gray-200 bg-white flex flex-col">

      <!-- Header -->
      <div class="p-4 border-b border-gray-200">
        <h1 class="text-xl font-semibold mb-4">Você</h1>

        <!-- Filtros -->
        <div class="flex items-center gap-3 mb-4">
          <span
            class="px-3 py-1 rounded-full text-sm font-medium cursor-pointer"
            :class="aba === 'finalizado' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'"
            @click="addAbaFilter('')"
          >
            Todos
          </span>

          <span
            class="px-3 py-1 rounded-full text-sm font-medium cursor-pointer"
            :class="aba === 'aguardando_cliente' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'"
            @click="addAbaFilter('aguardando_cliente')"
          >
            Aguardando Cliente
          </span>

          <span
            class="px-3 py-1 rounded-full text-sm font-medium cursor-pointer"
            :class="aba === 'cliente_respondeu' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'"
            @click="addAbaFilter('cliente_respondeu')"
          >
            Cliente Respondeu
          </span>

          <span
            class="px-3 py-1 rounded-full text-sm font-medium cursor-pointer"
            :class="aba === 'prioridade' ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-700'"
            @click="addAbaFilter('prioridade')"
          >
            Prioridade
          </span>
        </div>

        <!-- Barra de busca -->
        <div class="flex gap-2 mb-4">
          <div class="relative flex-1">
            <input
              type="text"
              placeholder="Pesquise por nome, telefone ou e-mail"
              class="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500"
              v-model="filters.cliente"
              @keyup.enter="buscarCliente"
            />
            <svg xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 absolute right-3 top-2.5 text-gray-400"
              fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 0 016.15 12.65z" />
            </svg>
          </div>

          <button
            type="button"
            class="bg-indigo-600 text-white text-sm font-medium px-4 rounded-md hover:bg-indigo-700"
            @click="buscarCliente"
          >
            Buscar cliente
          </button>
        </div>
        <!-- Ordenação -->
        <div class="flex justify-between items-center">
          <div>
           <label class="block text-xs text-gray-500">Ordenar por:</label>
            <select
              class="border border-gray-300 rounded-md px-2 py-1 text-sm"
              @change="applyOrdenarFilter($event.target.value)"
            >
              <option value="">Sem ordenação</option>
              <option value="novos">Mais novos</option>
              <option value="antigos">Mais antigos</option>
            </select>
          </div>

          <div>
            <label class="block text-xs text-gray-500">Visualizar</label>
            <select
              class="border border-gray-300 rounded-md px-2 py-1 text-sm text-gray-800"
            >
              <option>Tudo</option>
              <option>Bloqueio</option>
              <option>Venda por campanha</option>
              <option>Inativo</option>
              <option>Não interessado</option>
              <option>Esperando resposta</option>
              <option>Sem meio de contato</option>
              <option>Dados incorretos</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Lista -->
        <div
          v-for="p in pessoas"
          :key="p.id"
          @click="abrirChat(p)"
          class="flex items-center gap-3 px-4 py-3 border-b border-gray-200 cursor-pointer hover:bg-gray-100"
        >
          <div class="h-10 w-10 rounded-full bg-gray-300 flex items-center justify-center font-semibold text-gray-700">
            {{ p.nome[0].toUpperCase() }}
          </div>

          <div class="flex flex-col">
            <span class="font-medium text-gray-900">{{ p.nome}}</span>
            <span class="text-sm text-gray-500">Status da Rota: {{ p.status }}</span>
          </div>

        </div>
        <div class="flex justify-between items-center mt-2.5 space-x-4">
          <div class="flex items-center">
            <span class="text-sm text-gray-600">Página {{ currentPageLista }} de {{ totalPagesLista }} | Total de registros: {{ totalRecordsLista }}</span>
          </div>
          <div class="flex sticky items-center space-x-2">
            <button @click="previousPageListas" v-if="listasWhatsPrevPageUrl" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Anterior</button>
            <button @click="nextPageListas" v-if="listasWhatsNextPageUrl" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Próximo</button>
            <input type="number" v-model="pageNumberLista" min="1" :max="totalPagesLista" class="border border-gray-300 rounded-md px-2 py-1 text-sm" placeholder="Ir para..." />
            <button @click="goToPage" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Ir</button>
          </div>
        </div>
      </div>

    <!-- PAINEL DIREITO -->
    <div class="flex-1 flex flex-col" v-if="contatoSelecionado">

      <!-- Topo com nome -->
     <div class="p-4 border-b bg-white border-gray-300 font-semibold flex flex-col">
        <span>
          {{ contatoSelecionado.nome }}
        </span>

        <span class="text-gray-400 text-sm">
          {{ contatoSelecionado.telefone }}
        </span>
      </div>
      <!-- Mensagens -->
      <div class="flex-1 overflow-y-auto p-4 space-y-3" id="mensagens-container">
        <div
          v-for="m in mensagens"
          :key="m.id"
          :class="m.isCliente ? 'text-left' : 'text-right'"
        >
          <span
            class="inline-block px-4 py-2 rounded-lg"
            :class="m.isCliente
              ? 'bg-gray-200 text-gray-800'
              : 'bg-indigo-600 text-white'"
          >
            {{ m.texto }}
          </span>
        </div>

        <!-- Estado vazio -->
        <div v-if="mensagens.length === 0" class="text-center text-gray-400 mt-10">
          Nenhuma mensagem ainda. Inicie a conversa.
        </div>
      </div>
      <div v-if="!numeroInvalido()">
        <div class="p-4 border-t border-gray-300 bg-white"  v-if="podeEnviarMensagemNormal">
          <form @submit.prevent="onSendFormData" class="flex flex-col gap-2">
            <div class="flex items-center gap-2">
              <input
                v-model="novaMensagem"
                type="text"
                placeholder="Digite sua mensagem"
                class="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500"
                :disabled="loading"
              />

              <button
                type="submit"
                :disabled="loading || !novaMensagem.trim()"
                class="px-4 py-2 rounded-md bg-indigo-600 text-white font-medium
                      hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Enviar
              </button>
            </div>

            <button
              type="button"
              @click="finalizarAtendimento"
              :disabled="loading"
              class="w-full px-4 py-2 rounded-md bg-red-600 text-white font-medium
                    hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Finalizar atendimento
            </button>
          </form>
        </div>
        <div v-else>
          <!-- Botão de enviar template -->
          <button
            @click="templateOpen = true"
            class="w-full px-4 py-2 rounded-md bg-indigo-600 text-white font-medium hover:bg-indigo-700"
          >
            Enviar Template
          </button>
        </div>

          <button
              @click="getEditData"
              class="w-full px-4 py-2 rounded-md bg-indigo-600 text-white font-medium hover:bg-indigo-700 mt-4"
            >
            Agendar Visita
          </button>
        </div>
    </div>
    <!-- Placeholder quando não selecionou -->
    <div v-else class="flex-1 flex flex-col items-center justify-center text-gray-600">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14 text-gray-400 mb-4" fill="none"
        viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8l-4 1 1.1-3.2A7.922 7.922 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>

      <h3 class="text-lg font-semibold">Comece a falar com seus contatos!</h3>
      <p class="text-sm text-gray-500 mt-1">Selecione um contato na lista ao lado.</p>
    </div>

  </div>
</template>

<script>

import { pageVariables } from '@/views/insideviews/atendimentos_whats_app/PageVariablesAtendimentosWhatsApp';
import AtendimentoWhatsappRepository from '@/services/AtendimentoWhatsappRepository.vue';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import ListaDeAgendamentosRepository from '@/services/ListaDeAgendamentosRepository.vue';
import Pusher from 'pusher-js';
import Swal from "sweetalert2";
import AtendimentosWhatsAppTemplateForm from './AtendimentosWhatsAppTemplateForm.vue';
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import ListaDeAgendamentosForm from '../listas_de_agendamentos/ListaDeAgendamentosForm.vue';
import GruposRepository from '@/services/GruposRepository.vue';
import BadgesRepository from '@/services/BadgesRepository.vue';


export default {
  name: "AtendimentoView",
  async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.getLista();
    this.getTemplates();
	},
  data() {
    return {
      ...pageVariables,
      contatoSelecionado: null,
      loading: false,
      agendamentos: [],
			agendamentosNextPageUrl:"",
			agendamentosPrevPageUrl:"",
      totalPagesAgendamento:0,
      totalRecordsAgendamento:0,
      currentPageAgendamento:"",
      pageNumberAgendamento:"",
      listasWhats: [],
      listasWhatsNextPageUrl:"",
			listasWhatsPrevPageUrl:"",
      totalPagesLista:0,
      totalRecordsLista:0,
      currentPageLista:0,
      pageNumberLista:0,
      listasActualPage:"",
      onlineUser:{},
      pessoas: [],
      mensagens: [],
      mensagensActualPage: "",
      novaMensagem: "",
      agendamentoSelecionadoId : null,
      conversaId: null,
      pusher: null,
      canalAtendente: null,
      canalPrioridade: null,
      filters: {
        status: '',
        busca: '',
        cliente: ''
      },
      aba: "",
      editFormData:{},
      editingOpen: false,
      templateOpen: false,
      templatesWhats: [],
      dadosConversa: {},
      consultores:[]
    };
  },

  mounted() {
    this.initBroadcast();
  },

  methods: {
    async getLista(page = null){
			this.loading = true; 
      this.mensagensActualPage = page;
			const listasRepo = new AtendimentoWhatsappRepository();
			try {
        const finalUrl = page ?? this.buildUrlComFiltros();
				const response = await listasRepo.getAgendamentos(this.onlineUser.token,finalUrl);
				if (response?.status  === 200) {
					this.agendamentos = response.data.data;
					this.totalPagesAgendamento = response.data.last_page;
					this.totalRecordsAgendamento = response.data.total;
					this.currentPageAgendamento = response.data.current_page;
          this.getConsultores();
          if (response.data.next_page_url) {
            this.agendamentosNextPageUrl = response.data.next_page_url;
            console.log(this.agendamentosNextPageUrl)
          }else{
            this.agendamentosNextPageUrl = ""
          }
          if (response.data.agendamentosPrevPageUrl) {
            this.agendamentosPrevPageUrl = response.data.prev_page_url;
          }else{
            this.agendamentosPrevPageUrl = ""
          }
          this.loading = false; 
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error); 
			}
		},
    handleAgendamentoSelecionado(id){
      this.agendamentoSelecionadoId = id;
      this.getListaWhatsApp(id);
    },
    previousPageAgendamento(){
      this.getLista(this.agendamentosPrevPageUrl);
    },
    nextPageAgendamento(){
      this.getLista(this.agendamentosNextPageUrl);
    },

    previousPageListas(){
      this.getListaWhatsApp(this.agendamentoSelecionadoId,null,this.listasWhatsPrevPageUrl);
    },
    nextPageListas(){
      this.getListaWhatsApp(this.agendamentoSelecionadoId,null,this.listasWhatsNextPageUrl);
    },
    goToListas(number) {
      let url = this.listasActualPage;
      if (url.includes('page=')) {
        url = url.replace(/page=\d+/, 'page=' + number);
      } else {
        url += (url.includes('?') ? '&' : '?') + 'page=' + number;
      }

      this.getListaWhatsApp(this.agendamentoSelecionadoId,null,url);
    },
    goToAgendamento(number){
      let url = this.mensagensActualPage;
      if (url.includes('page=')) {
        url = url.replace(/page=\d+/, 'page=' + number);
      } else {
        url += (url.includes('?') ? '&' : '?') + 'page=' + number;
      }
			this.getLista(this.url)
		},
    async getListaWhatsApp(id = null, page = null, fullPage = null) {
      this.loading = true;


      if (id) this.agendamentoSelecionadoId = id;
      
      let finalUrl = this.buildUrlComFiltrosWhats(page);

      if (fullPage) {
        finalUrl = fullPage;
      }
      
      if (!finalUrl) {
        this.loading = false;
        return;
      }
      this.listasActualPage = finalUrl;
      const listasRepoWhatsRepo = new ListaDeAgendamentosRepository();
      try {
        const response = await listasRepoWhatsRepo.getListaWhatsApp(this.onlineUser.token, finalUrl);
        if (response?.status === 200) {
          this.pessoas = response.data.data
            .map(item => {
              const origem = item.segurado ?? item.dependentes;
              if (!origem) return null;
              return {
                id: item.id,
                nome: origem.nome,
                telefone: origem.telefone,
                status: item.status
              };
            })
            .filter(Boolean);
          this.totalPagesLista = response.data.last_page;
          this.totalRecordsLista = response.data.total;
          this.currentPageLista = response.data.current_page;

          this.listasWhatsNextPageUrl = response.data.next_page_url ?? "";
          this.listasWhatsPrevPageUrl = response.data.prev_page_url ?? "";
          this.loading = false;
        }
      } catch (error) {
        handleUnauthorized(error);
      } finally {
        this.loading = false;
      }
    },
    abrirChat(contato) {
      this.getMensagens(contato.id);
      this.contatoSelecionado = contato;
    },
    async onSendFormData(){
			const listasRepo = new AtendimentoWhatsappRepository();
      const payload = {
        conversa_id: this.conversaId ?? "",
        lista_agendamento_id: this.contatoSelecionado.id,
        mensagem: this.novaMensagem,
        cliente_id: this.contatoSelecionado.telefone.replace(/\D/g, '')
      };

      this.loading = true;
			try {
				const response = await listasRepo.createMensagem(payload,this.onlineUser.token);
        const newMessageSent =  response.data?.data;
        const mensagem = {
          id: newMessageSent.id,
          texto: newMessageSent.conteudo,
          autor: newMessageSent.autor,
          isCliente: false,
          created_at: newMessageSent.created_at
        };
        if (mensagem) {
          this.mensagens.push(mensagem);
        }
        this.loading = false; 
        this.novaMensagem = "";
        } catch (error) {
          handleUnauthorized(error); 
        }	
		},
    async getMensagens(id){
			this.loading = true; 
			const listasRepo = new AtendimentoWhatsappRepository();
			try {
				const response = await listasRepo.getConversas(id,this.onlineUser.token);
				if (response?.status  === 200) { 
          const conversa = response.data;

          if (conversa) {
            this.conversaId = conversa.id;
            this.dadosConversa = conversa;
            this.listaAgendamentoId = conversa.lista_agendamento_id;
            this.mensagens = (conversa.mensagens ?? []).map(m => {
            
              return {
                id: m.id,
                texto: m.conteudo,
                autor: m.autor,
                isCliente: m.autor === 'cliente',
                created_at: m.created_at
              };
            });
          } else {
            this.conversaId = null;
            this.mensagens = [];
          }
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error); 
			}
		},
    async getTemplates(){
			this.loading = true; 
			const listasRepo = new AtendimentoWhatsappRepository();
			try {
				const response = await listasRepo.getTemplates(this.onlineUser.token);
				if (response?.status  === 200) { 
          this.templatesWhats = response.data;
          this.loading = false; 
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error); 
			}
		},
    async enviarTemplate(dados) {
      const variables = { ...dados.valores }
      const payload = {
        cliente_id: this.contatoSelecionado.telefone.replace(/\D/g, ''),
        conversa_id: this.conversaId ?? "",
        lista_agendamento_id: this.contatoSelecionado.id,
        template_name: dados.template_name,
        language: 'pt_BR',
        variables,
        header: {}
      }
      const listasRepo = new AtendimentoWhatsappRepository();
      this.loading = true;
			try {
				const response = await listasRepo.enviarTemplate(payload,this.onlineUser.token);
        if (response?.status === 200) {
          const newMessageSent =  response.data?.data;
          const mensagem = {
            id: newMessageSent.id,
            texto: newMessageSent.conteudo,
            autor: newMessageSent.autor,
            isCliente: newMessageSent.autor,
            created_at: newMessageSent.created_at
          };
          if (mensagem) {
            this.mensagens.push(mensagem);
          }
          this.loading = false; 
        }
      } catch (error) {
        this.loading = false;
        handleUnauthorized(error); 
      }	
    },
    addAbaFilter(value){
      this.aba = value;
      this.filters.status = "";
      var filterValue = value;
      this.filters.status = filterValue;
      this.getListaWhatsApp(this.agendamentoSelecionadoId);
    },
    applyOrdenarFilter(value) {
      console.log(value)
      this.filters.ordenar = value;
      console.log(this.filters)
      this.getListaWhatsApp(this.agendamentoSelecionadoId);
    },
    numeroInvalido() {
      if (!this.contatoSelecionado || !this.contatoSelecionado.telefone) return false;

      const telefone = this.contatoSelecionado.telefone.replace(/\D/g, '');

      return (
        telefone === '5511999999999' ||
        telefone === '11999999999' ||
        telefone === '999999999'
      );
    },
    buscarCliente(){
      this.getListaWhatsApp(this.agendamentoSelecionadoId);
    },
    buildUrlComFiltros() {
      let url = this.listaDeAgendamentoPage;
      const params = [];

      if (this.filters.status) {
        params.push(`status=${this.filters.status}`);
      }

      if (this.filters.busca) {
        params.push(`busca=${this.filters.busca}`);
      }

      if (this.filters.cliente) {
        params.push(`cliente=${this.filters.cliente}`);
      }

      if (params.length) {
        url += '?' + params.join('&');
      }

      return url;
    },


    buildUrlComFiltrosWhats() {

      const agendamentoId = this.agendamentoSelecionadoId;
      if (!agendamentoId) return null;

      let url = `${this.listaDeAgendamentoPageConmFiltro}${agendamentoId}`;
      const params = [];
      if (this.filters.status) {
        params.push(`status=${this.filters.status}`);
      }

      if (this.filters.busca) {
        params.push(`busca=${this.filters.busca}`);
      }

      if (this.filters.cliente) {
        params.push(`cliente=${this.filters.cliente}`);
      }

      if (this.filters.ordenar) {
        params.push(`ordenar=${this.filters.ordenar}`);
      }
      if (params.length) {
        url += '?' + params.join('&');
      }
      return url;
    },

    sanitizeChannel(value) {
      if (!value) return null;

      return value
        .toLowerCase()
        .replace(/@/g, "__at__")
        .replace(/\./g, "__dot__")
        .replace(/[^a-z0-9_-]/g, "");
    },

    initBroadcast() {
      console.log("entrei initBroadcast");

      try {
       
        if (!this.onlineUser || !this.onlineUser.user.email) {
          console.log("onlineUser/email vazio:", this.onlineUser);
          return;
        }

        if (typeof Pusher === "undefined") {
          console.log("Pusher não está carregado/importado (Pusher is undefined)");
          return;
        }

        Pusher.log = function (msg) {
          console.log("📡 PusherLog:", msg);
        };

        const APP_KEY = process.env.VUE_APP_REVERB_APP_KEY;
        try {
          this.pusher = new Pusher(APP_KEY, {
              cluster: "mt1",
              wsHost: "justechv2.sienaseguros.com.br",
              wsPort: 443,
              wssPort: 443,
              forceTLS: true,
              enabledTransports: ['ws', 'wss'],
              disableStats: true
          });
        } catch (e) {
          console.error("CONSTRUCTOR EXPLODIU:", e);
        }
        console.log("Pusher instanciado");

        this.pusher.connection.bind("state_change", (st) => {
          console.log("state_change:", st);
        });

        this.pusher.connection.bind("connected", () => {
          console.log(" Conectado ao Reverb | socket_id:", this.pusher.connection.socket_id);
        });

        this.pusher.connection.bind("error", (err) => {
          console.log("CONNECTION ERROR FULL:", JSON.stringify(err, null, 2));
        });

       
        const email = this.onlineUser.user.email;
        const canalEmail = this.sanitizeChannel(email);
        console.log("email:", email, "=> canal:", canalEmail);

        this.canalAtendente = this.pusher.subscribe(`atendente.${canalEmail}`);
        this.canalPrioridade = this.pusher.subscribe("prioridade");

        this.canalAtendente.bind("pusher:subscription_succeeded", () => {
          console.log("Inscrito no canal atendente");
        });
        this.canalAtendente.bind("pusher:subscription_error", (status) => {
          console.log("Erro ao inscrever atendente. status:", status);
        });

        this.canalPrioridade.bind("pusher:subscription_succeeded", () => {
          console.log("Inscrito no canal prioridade");
        });
        this.canalPrioridade.bind("pusher:subscription_error", (status) => {
          console.log("Erro ao inscrever prioridade. status:", status);
        });
        this.canalAtendente.bind("mensagem.recebida", (data) => this.onMensagemRecebida(data));
        this.canalPrioridade.bind("mensagem.recebida", (data) => this.onMensagemPrioridade(data));

        console.log("initBroadcast terminou");
      } catch (e) {
        console.log("initBroadcast explodiu:", e);
      }
    },

    onMensagemRecebida(eventData) {
      console.log("nova mensagem recebida pelo webhook: ", eventData);
      
      const payloadMensagem = eventData?.mensagem;
      if (!payloadMensagem) return;

      // Se a mensagem que chegou for da conversa que o usuário está visualizando agora...
      if (String(payloadMensagem.conversa_id) === String(this.conversaId)) {
        
        // Formatar para o padrão do Array da View
        const novaMensagem = {
          id: payloadMensagem.id,
          texto: payloadMensagem.conteudo,
          autor: payloadMensagem.autor,
          isCliente: payloadMensagem.autor === 'cliente',
          created_at: payloadMensagem.created_at
        };

        // Adiciona à tela
        this.mensagens.push(novaMensagem);

        // Opcional: fazer a barra de scroll descer pro final
        this.$nextTick(() => {
          this.rolarParaFinalConversa();
        });
      } else {
        // Se quisermos no futuro avisar de nova mensagem em outra conversa,
        // pode ser feito aqui (ex: mudar cor na aba lateral)
      }
    },

    onMensagemPrioridade(eventData) {
      console.log("canal de prioridade recebeu evento: ", eventData);
      // Mesma lógica de validação de tela, caso o admin esteja vendo esta conversa
      const payloadMensagem = eventData?.mensagem;
      if (!payloadMensagem) return;

      if (String(payloadMensagem.conversa_id) === String(this.conversaId)) {
        const novaMensagem = {
          id: payloadMensagem.id,
          texto: payloadMensagem.conteudo,
          autor: payloadMensagem.autor,
          isCliente: payloadMensagem.autor === 'cliente',
          created_at: payloadMensagem.created_at
        };
        this.mensagens.push(novaMensagem);
        this.$nextTick(() => {
          this.rolarParaFinalConversa();
        });
      }
    },

    rolarParaFinalConversa() {
      const containerMensagens = document.getElementById('mensagens-container');
      if (containerMensagens) {
        containerMensagens.scrollTop = containerMensagens.scrollHeight;
      }
    },

    finalizarAtendimento() {
      let idLista = this.listaAgendamentoId;
      console.log(idLista);
      if (!idLista) {
        Swal.fire({
          icon: 'error',
          title: 'Ops!',
          text: 'Não encontrei o lista_agendamento_id deste contato.',
          confirmButtonColor: '#3085d6',
        });
        return;
      }

      Swal.fire({
        icon: 'warning',
        title: 'Finalizar atendimento?',
        text: 'Tem certeza que deseja finalizar este atendimento? Essa ação vai marcar a conversa como finalizada.',
        showCancelButton: true,
        confirmButtonText: 'Sim, finalizar',
        cancelButtonText: 'Não',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.confirmarFinalizacaoAtendimento(idLista);
        }
      });
    },

    async confirmarFinalizacaoAtendimento(listaAgendamentoId) {
      this.loading = true; 
			const listasRepo = new AtendimentoWhatsappRepository();
			try {
				const response = await listasRepo.finalizarAtendimento(listaAgendamentoId,this.onlineUser.token);
				if (response?.status  === 200) { 
          this.loading = false;
          this.getListaWhatsApp(listaAgendamentoId);
				}
        } catch (error) {
          this.loading = false; 
          handleUnauthorized(error); 
        }
    },

    async getConsultores(){
			const groupsRepo = new GruposRepository();
			try {
				const response = await groupsRepo.getGroupMembers(this.onlineUser.token,this.consultoresPage);
				if (response?.status === 200) {
					this.consultores = response.data
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},

    async getEditData(){
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.getLista(this.pageListas,this.onlineUser.token,this.listaAgendamentoId);
				if (response?.status === 200) {
					this.editFormData = response.data.agendamento
					this.editingOpen =true
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},

    async onSendEditingData(data) {
			this.loading = true; 
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.updateLista(this.pageListas, this.onlineUser.token, this.listaAgendamentoId, data);
				if (response?.status === 200) {
					this.editingOpen = false;
					this.loading = false; 
				} else {
					this.loading = false; 
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},

    async seguradoBadge(badge){
			this.loading = true;
			const badgeRepo = new BadgesRepository();
			try {
				const response = await badgeRepo.createBadge(this.pageBadge,badge,this.onlineUser.token);
				
				if (response?.status === 201) {
					this.getEditData(this.editingListaId);
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	

		},

		async deleteBadge(id){
			const badgeRepo = new BadgesRepository();
			try {
				const response = await badgeRepo.deleteBadge(this.pageBadge,this.onlineUser.token,id);
				
				if (response?.status === 200) {
					this.getEditData(this.editingListaId);
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	
		},

		async deleteEmpresa(id){
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.desvincularEmpresaLista(id,this.onlineUser.token);
				
				if (response?.status === 200) {
					this.getEditData(this.editingListaId);
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	
		},
  },

  computed: {
    //modifiquei essa função pois havia complexado ela demais e dava erro na seleção com autores diferentes
    podeEnviarMensagemNormal() {
      if (!this.mensagens?.length) return false;

      // 1) Procura a ÚLTIMA mensagem do cliente
      const ultimaMsgCliente = [...this.mensagens]
          .reverse()
          .find(msg => msg.autor === 'cliente');

      if (!ultimaMsgCliente) return false;

      // 2) Calcula diferença de tempo
      const agora = new Date();
      const dataUltima = new Date(ultimaMsgCliente.created_at);

      const dentroDaJanela24h =
          (agora - dataUltima) < (24 * 60 * 60 * 1000);

      // 3) Retorna verdadeiro se estiver no prazo
      return dentroDaJanela24h;
    },

    deveUsarTemplate() {
      return !this.podeEnviarMensagemNormal;
    },

  },

  components:{
    AtendimentosWhatsAppTemplateForm,
    CommonLoading,
    ListaDeAgendamentosForm
  }

};
</script>
